import { defineMessages } from 'react-intl';

const messages = defineMessages({
  valueTypeLabel: {
    id: 'DelimitedItemInput.ValueTypeLabel',
    defaultMessage: 'Identifier Type',
  },
  valueTypeHelperText: {
    id: 'DelimitedItemInput.ValueTypeHelperText',
    defaultMessage: 'The type of identifier to search on',
  },
  itemNumberLabel: {
    id: 'DelimitedItemInput.ItemNumberLabel',
    defaultMessage: 'Item Number',
  },
  upcLabel: {
    id: 'DelimitedItemInput.UPCLabel',
    defaultMessage: 'UPC',
  },
});

export default messages;
